import { filterParams } from '../assets/helpers/funciones';
import { authInstance } from './axios';
let url = process.env.REACT_APP_API_URL;

export const campaignBegin = {
  getCampaign: async (params) => {
    const response = await authInstance
      .get(
        `${url}/parameters/beginDateDelayCampaign?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },
  updateCampaign: async (campaignId, data) => {
    const response = await authInstance
      .put(`${url}/parameters/beginDateDelayCampaign/${campaignId}`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
  createCampaign: async (data) => {
    const response = await authInstance
      .post(`${url}/parameters/beginDateDelayCampaign`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
  changeStatusCampaign: async (campaignId) => {
    const response = await authInstance
      .put(`${url}/parameters/beginDateDelayCampaign/${campaignId}/enableDisable`, {})
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  }
};
